@if (vm$ | async; as vm) {
    @if (standalone && title) {
        <ms-widget-header [title]="title" />
    }
    <ng-container *msComponentProxy="teamPagesCompetitionComponent" />
}
